import utils from '../utils';
import videojs from 'video.js';
import VkAuthProvider from './vk-auth-provider';
import FacebookAuthProvider from './facebook-auth-provider';
import TwitterAuthProvider from './twitter-auth-provider';
import EmailAuthProvider from './email-auth-provider';
import RdstvAuthProvider from './rdstv-auth-provider';

export default class AuthService extends videojs.EventTarget {
  constructor(options) {
    super();
    this.options = options;
    this.providers = {};
    this._createProviders();
  }

  get availableProviders() {
    return Object.keys(this.providers);
  }

  /**
   * Проверка допустимости использования сервисов авторизации и создание экземпляров классов,
   * отвечающих за их работу
   */
  _createProviders() {
    if (this.options.vkApiId && !utils.iOSUser()) {
      this.providers['vk'] = new VkAuthProvider(this.options.vkApiId);
    }

    if (this.options.rdsTvProvider) {
      this.providers['rdstv'] = new RdstvAuthProvider();
    }
    let firebaseConfig = this.options.firebase.config;
    let firebaseProviders = this.options.firebase.providers;

    if (firebaseConfig) {
      if (firebaseProviders.includes('facebook')) {
        this.providers['facebook'] = new FacebookAuthProvider(firebaseConfig);
      }
      if (firebaseProviders.includes('twitter')) {
        this.providers['twitter'] = new TwitterAuthProvider(firebaseConfig);
      }
      if (firebaseProviders.includes('email')) {
        this.providers['email'] = new EmailAuthProvider(firebaseConfig, this.options.returnUrl);
      }
    }

    Object.values(this.providers).forEach(provider => {
      provider.on('providerAuthorized', event => this.trigger(event));
      provider.on('providerInstructionsSent', event => this.trigger(event));
      provider.on('providerConfirmedAuthorization', event => this.trigger(event));
      provider.on('providerError', event => this.trigger(event));
    });
  }

  /**
   * Загрузка скриптов для работы каждого сервиса авторизации
   */
  loadProviderScripts() {
    let loadedScripts = 0;
    let loeadCallback = () => {
      loadedScripts++;
      if (loadedScripts == this.availableProviders.length) {
        this.scriptsLoaded = true;
        this.trigger('scriptsLoaded');
      }
    }

    Object.values(this.providers).forEach(provider => {
      provider.one('scriptLoaded', loeadCallback);
      provider.loadScript()
    });
  }

  /**
   * Проверка авторизации пользователя
   * NOTE: актуально только для авторизации по email, таковы особенности работы Firebase
   *
   * @returns {boolean} - Авторизован ли пользователь
   */
  isUserAuthorized() {
    const emailAuthProvider = this.providers['email'];
    const rdstvAuthProvider = this.providers['rdstv'];
    if (!emailAuthProvider && !rdstvAuthProvider) {
      return false;
    }
    if (rdstvAuthProvider) return rdstvAuthProvider.isUserAuthorized();
    if (emailAuthProvider) return emailAuthProvider.isUserAuthorized();
  }

  /**
   * Попытка восстановления данных авторизации пользователя
   * NOTE: актуально только для авторизации по email, таковы особенности работы Firebase
   */
  restoreUserAuth() {
    const emailAuthProvider = this.providers['email'];
    const rdstvAuthProvider = this.providers['rdstv'];
    if (!emailAuthProvider && !rdstvAuthProvider) return;

    if (rdstvAuthProvider) rdstvAuthProvider.authorize();
    if (emailAuthProvider) emailAuthProvider.restoreUserAuth();
  }

  /**
   * Авторизация пользователя одним из способов авторизации
   *
   * @param {String} provider - Название способа авторизации
   * @param {Object} authData - Дополнительные данные для авторизации. Используется при авторизации через
   * почту
   */
  authorize(provider, authData) {
    const authProvider = this.providers[provider];
    authProvider && authProvider.authorize(authData);
  }
}
